<section>
  <h1>Results</h1>
  <ness-results-filter *ngIf="filterModel" [storageKey]="storageKey" (filterModel)="applyFilters($event)"></ness-results-filter>
  <a *removeIfUnauthorizedResult="canCreate" (click)="newResult()" class="btn btn-active mb-3">Add Result</a>
  <p-table #dt [columns]="cols" [value]="resultsData" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" selectionMode="single" [(selection)]="selectedResult" [autoLayout]="true" responsiveLayout="scroll">
    <ng-template pTemplate="caption">
      <div class="d-flex flex-wrap p-2 mx-2 filter-status font-size-sm">
        <ness-paged-loading-status *ngIf="loading" [startRow]="loadingStartRow" [endRow]="loadingEndRow" [messageTemplate]="messageTemplate"></ness-paged-loading-status>
        <div class="ms-md-2 ms-lg-auto me-2">
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></span>
            <input type="text" class="form-control" name="resultsGridGlobalFilter" placeholder="Global filter" (input)="dt.filterGlobal($event['target']['value'], 'contains')" aria-label="Globally filter the results grid">
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" scope="col" class="text-nowrap">
          {{col.header}} <p-sortIcon *ngIf="col.field !== 'Defendants' " [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <ng-container *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <th scope="row" *ngSwitchCase="'TrackingNumber'">
              <button type="button" class="btn btn-link p-0" aria-label="{{ !!rowData.TrackingNumber ?  'Tracking Number ' +rowData.TrackingNumber+   'details': 'View details'}}" (click)="viewDetails(rowData)">{{ !!rowData.TrackingNumber ? rowData.TrackingNumber : 'View details'}}</button>
            </th>
            <td *ngSwitchCase="'CreatedDate'">
              {{rowData[col.field] | utcToLocal:'MM/dd/yyyy'}}
            </td>
            <td *ngSwitchCase="'LastUpdateDate'">{{rowData[col.field] | utcToLocal:'MM/dd/yyyy'}}</td>
            <td *ngSwitchDefault>{{rowData[col.field]}}</td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          No result found.
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
<p-sidebar (onShow)="onShowSidebar()" [(visible)]="openSidebar" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
  <ness-results-detail *ngIf="openViewDetailForm" [resultId]="selectedResultId$ | async"></ness-results-detail>
  <button type="button" (click)="openSidebar = openViewDetailForm = false" class="btn btn-active my-3">Close</button>
</p-sidebar>
